import contact from './contact'
import comment from './comment'
import customer from './customer'
import reminder from './reminder'
import call from './call'
import task from './task'
import service from './service'
import estimate from './estimate'
import contract from './contract'
import invoice from './invoice'
import upload from './upload'
import proposal from './proposal'
import sourceApp from './source-app'
import email from './email'

export default {
  contact,
  comment,
  customer,
  reminder,
  call,
  task,
  service,
  estimate,
  contract,
  invoice,
  upload,
  proposal,
  source_app: sourceApp,
  email
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/model/index.js